import React, { useRef } from "react";

import type { Swiper as SwiperInstance } from "swiper";
import AngleLeftIcon from "@vahak/core/dist/standard-icons/angle-left.svg";
import RightArrowIcon from "@vahak/core/dist/standard-icons/right-arrow.svg";

import Swipper from "../../Swipper/Swipper";
import Styles from "./CustomerSaysSection.module.scss";
import useHomepageV2Translation from "../hooks/useHomepageV2Translation";
import HomepageV2Animate from "../animate/HomepageV2Animate";
import TestimonialCardV2 from "./testimonial-card/TestimonialCardV2";
import testimonials from "./testimonials.json";

const TESTIMONIALS_SWIPER_BREAKPOINTS = {
    576: {
        slidesPerView: 2,
        spaceBetween: 24
    },
    992: {
        slidesPerView: 3,
        spaceBetween: 24
    }
};

const CustomerSaysSection = () => {
    const { t } = useHomepageV2Translation();
    const swiperRef = useRef<SwiperInstance | null>(null);
    const paginationRef = useRef<HTMLDivElement>(null);

    return (
        <div className={Styles.container}>
            <HomepageV2Animate variant="fade-up" className={Styles.header}>
                <p className={Styles.eyebrow}>{t("homepageV2:customerSays.eyebrow")}</p>
                <h2 className={Styles.title}>
                    <span className={Styles.titleLine}>{t("homepageV2:customerSays.title")}</span>
                    <span className={Styles.titleHighlight}>{t("homepageV2:customerSays.titleHighlight")}</span>
                </h2>
            </HomepageV2Animate>

            <HomepageV2Animate variant="fade-up" delay={120} className={Styles.carouselWrapper}>
                <div className={Styles.carouselShell}>
                    <button
                        type="button"
                        className={Styles.prevBtn}
                        aria-label="Previous testimonial"
                        onClick={() => swiperRef.current?.slidePrev()}
                    >
                        <AngleLeftIcon aria-hidden />
                    </button>

                    <div ref={paginationRef} className={Styles.dots} />

                    <div className={Styles.swiperTrack}>
                        <Swipper
                            className={Styles.testimonialsSwiper}
                            cssMode={false}
                            loop
                            navigation={false}
                            autoplay={{ delay: 5000, disableOnInteraction: false, pauseOnMouseEnter: true }}
                            slidesPerView={1}
                            spaceBetween={16}
                            breakpoints={TESTIMONIALS_SWIPER_BREAKPOINTS}
                            mousewheel={false}
                            paginationRef={paginationRef}
                            onSwiper={(swiper) => {
                                swiperRef.current = swiper;
                            }}
                            list={testimonials.map((item) => ({
                                key: item.name,
                                node: (
                                    <div className={Styles.slide}>
                                        <TestimonialCardV2
                                            quote={item.quote}
                                            name={item.name}
                                            role={item.role}
                                            initials={item.initials}
                                        />
                                    </div>
                                )
                            }))}
                        />
                    </div>

                    <button
                        type="button"
                        className={Styles.nextBtn}
                        aria-label="Next testimonial"
                        onClick={() => swiperRef.current?.slideNext()}
                    >
                        <RightArrowIcon aria-hidden />
                    </button>
                </div>
            </HomepageV2Animate>
        </div>
    );
};

export default CustomerSaysSection;
